import { render } from "./ConsociateComponent.vue?vue&type=template&id=93d8543c&scoped=true"
import script from "./ConsociateComponent.vue?vue&type=script&lang=js"
export * from "./ConsociateComponent.vue?vue&type=script&lang=js"

import "./ConsociateComponent.vue?vue&type=style&index=0&id=93d8543c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d8543c"]])

export default __exports__